import { useEffect, useRef } from 'react';

export function useInterval(callback: () => void, delay: number): void {
  const savedCallback = useRef<() => void>(callback);
  const intervalID = useRef<number | null>(null);

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function stop(): void {
      if (intervalID.current !== null) {
        window.clearInterval(intervalID.current);
      }
    }

    function tick(): void {
      savedCallback.current();
    }

    stop();
    if (delay !== null) {
      intervalID.current = window.setInterval(tick, delay);
    }

    return stop;
  }, [delay]);
}
